export default "__VITE_ASSET__kitQgtOy__"